import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "./Layout";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const NextArrow = ({ onClick }) => {
  return (
    <img
      className="arrow-prev slick-arrow"
      onClick={onClick}
      src="/assets/images/arrow-left.svg"
      alt=""
    />
  );
};

const PrevArrow = ({ onClick }) => {
  return (
    <img
      className="arrow-next slick-arrow"
      onClick={onClick}
      src="/assets/images/arrow-right.svg"
      alt=""
    />
  );
};

const Home = () => {
  const settings = {
    infinite: true,
    dots: false,
    vertical: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    verticalSwiping: false,
    nextArrow: <NextArrow onClick />,
    prevArrow: <PrevArrow onClick />,
  };

  const navigate = useNavigate();

  const isUser = () => {
    // if (localStorage.getItem('access_token')) {
    //     navigate('/user/dashboard')
    // }
  };

  useEffect(() => {
    isUser();
  });

  return (
    <Layout>
      <div className="home-page">
        <main>
          <section className="banner-block">
            <img
              src="/assets/images/banner-img.png"
              alt=""
              className="img-fluid"
            />
            <div className="container">
              <div className="row align-items-center h-100">
                <div className="col-md-6">
                  <div className="banner-content">
                    <h2>Shaping your energy career</h2><br/>
                    <h6> NEW ERA ENERGY TRANSITION</h6>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="intro-title">
            <div className="container">
              <div className="row">
                <div className="col-md-10 offset-md-1 col-12">
                  <h4>goneet - Home for Energy Sector People</h4>
                  <p>
                    {/* goneet is the home of all Energy Sector people – Join and
                    develop your industry standard Profile, Build & Develop your
                    energy Network, Find your place in your industry wide
                    discipline PEER Group and enhance your industry prospects. */}

goneet is the home of all Energy Sector people – Join and develop
your industry standard Profile and enhance your industry prospects.
Build & Develop your energy Network, Find your place within your
industry discipline PEER Group.
                  </p>
                  <ul className="features-list">
                    <li className="text-center">
                      <div className="img-wrap text-center">
                        <img
                          src="/assets/images/icons/profile.svg"
                          alt="neet"
                        />
                      </div>
                      <div className="feature-name" style={{fontSize:'16px'}}>
                        MY <strong>Profile</strong>
                      </div>
                    </li>
                    <li className="text-center">
                      <div className="img-wrap text-center">
                        <img
                          src="/assets/images/icons/analytics.svg"
                          alt="neet"
                        />
                      </div>
                      <div className="feature-name" style={{fontSize:'16px'}}>
                        MY <strong> Analytics</strong>
                      </div>
                    </li>
                    <li className="text-center">
                      <div className="img-wrap text-center">
                        <img
                          src="/assets/images/icons/network.svg"
                          alt="neet"
                        />
                      </div>
                      <div className="feature-name" style={{fontSize:'16px'}}>
                        MY <strong> Network</strong>
                      </div>
                    </li>
                    <li className="text-center">
                      <div className="img-wrap text-center">
                        <img
                          src="/assets/images/icons/performance.svg"
                          alt="neet"
                          className=""
                        />
                      </div>
                      <div className="feature-name" style={{fontSize:'16px'}}>
                        MY <strong>Performance</strong>
                      </div>
                    </li>
                  </ul>
                  <Link to="/" className="scroll-down">
                    <img src="/assets/images/arrow-down.svg" alt="arrow-down" />
                  </Link>
                </div>
              </div>
            </div>
          </section>
          <section className="how-it-works">
            <div className="container">
              <div className="row">
                <div className="col-12 text-center d-none">
                  <h2>How it works</h2>
                </div>
                <div className="col-md-10 offset-md-1 col-12 text-center">
                  <div className="video-wrap">
                    <div className="frame-holder">
                      <iframe
                        width="100%"
                        height="400"
                        // src="https://www.youtube.com/embed/43csxMbD5yk"
                        src="https://www.youtube.com/embed/EK6F_5Mj0ag"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="two-col-section">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-5 col-md-6 col-12">
                  <div className="inner-content">
                    <h2>
                      A global connection,
                      <br />
                      your energy future
                    </h2>
                    <p>
                      {/* Build and develop your energy Network, establish your
                      position within your Discipline, Industry wide and grow
                      your own discipline PEER group. */}

Build and develop your own energy Network, establish your position
within your Discipline PEER Group and transform your Profile and
your potential.                                                                         
                    </p>
                    <Link to="/" className="common-btn btn-blue-border d-none">
                      WAYS TO CONNECT
                    </Link>
                  </div>
                </div>
                <div className="col-lg-7 col-md-6 col-12">
                  <div className="img-wrap">
                    <figure>
                      <img
                        className="img-fluid w-100"
                        src="\assets\images\img1.png"
                        alt="neet"
                      />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="testimonial-block text-center">
            <div className="container">
              <div className="row">
                <div className="col-md-10 offset-md-1 col-12">
                  <div className="testimonial-slider-wrap">
                    <div id="testimonialCarousel" className="carousel-slider">
                      <Slider {...settings}>
                        <div className="single-item">
                          <div className="slide-content">
                            <div className="content">
                              goneet industry standard Profile transformed my
                              prospects <br/> and helped me secure my next contract.
                            </div>
                            <div className="footer">
                              <div className="member-name">Grant Ahmad</div>
                              <div className="position-title">
                                Offshore Maintenance Tech
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="single-item">
                          <div className="slide-content">
                            <div className="content">
                            goneet’s industry Profile is replacing CV’s as it allows us to quickly
                             and accurately identify the right people for the discipline requirements
                            </div>
                            <div className="footer">
                              <div className="member-name">Lesley Grant</div>
                              <div className="position-title">
                                Principle Oil & Gas Recruitment Consultant 
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        <div className="single-item">
                          <div className="slide-content">
                            <div className="content">
                            after developing my industry Profile, I sent to various agencies
                             <br/> and received
                             three separate job offers
                            </div>
                            <div className="footer">
                              <div className="member-name">John Smith</div>
                              <div className="position-title">
                                Snr Piping Engineer
                              </div>
                            </div>
                          </div>
                        </div>


                       
                      </Slider>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="get-started">
                    <Link to="/signin" className="common-btn btn-blue btn-l">
                      GET STARTED NOW
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="img-list">
            <div className="container-fluid">
              <div className="row">
                <div className="col">
                  <figure>
                    <img
                      className="img-fluid w-100"
                      src="/assets/images/img2.png"
                      alt="neet"
                    />
                  </figure>
                </div>
                <div className="col">
                  <figure>
                    <img
                      className="img-fluid w-100"
                      src="/assets/images/img3.png"
                      alt="neet"
                    />
                  </figure>
                </div>
                <div className="col">
                  <figure>
                    <img
                      className="img-fluid w-100"
                      src="/assets/images/img4.png"
                      alt="neet"
                    />
                  </figure>
                </div>
                <div className="col">
                  <figure>
                    <img
                      className="img-fluid w-100"
                      src="/assets/images/img5.png"
                      alt="neet"
                    />
                  </figure>
                </div>
                <div className="col">
                  <figure>
                    <img
                      className="img-fluid w-100"
                      src="/assets/images/img6.png"
                      alt="neet"
                    />
                  </figure>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    </Layout>
  );
};
export default Home;
